import script from "./ToothArchRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ToothArchRow.vue?vue&type=script&setup=true&lang=js"

import "./ToothArchRow.vue?vue&type=style&index=0&id=19149f06&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19149f06"]])

export default __exports__